///
/// EarthBrowser
///
/// Created by Matt Giger on 10/23/2026
/// Copyright (c) 2026 Geodata Labs
///
/// Where dataset browsers live on screen: the right-side rail + panel on
/// desktop, the bottom detent sheet on phones. See
/// documentation/frontend/DATA_DOCK.md.
///

import { useIsMobile } from "@/components/utils/use-mobile"
import { BottomDrawer } from "./BottomDrawer"
import { RightDock } from "./RightDock"

export function DataDock() {
	const isMobile = useIsMobile()
	return isMobile ? <BottomDrawer /> : <RightDock />
}
